<div mat-dialog-title>
  <h2>{{ 'dialog.necessity.' + data.type + '.title' | translate }}</h2>
</div>

<mat-dialog-content>
  <form [formGroup]="formGroup">
    <div fxLayout="column">
      <mat-form-field fxFlex>
        <mat-label>{{ 'dialog.necessity.necessity' | translate }}</mat-label>
        <mat-select formControlName="status">
          <mat-option *ngFor="let status of statuses" [value]="status.value">
            {{ status.viewValue | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label>{{ 'dialog.necessity.insurance' | translate }}</mat-label>
        <mat-select formControlName="insurance">
          <mat-option *ngFor="let insurance of insurances" [value]="insurance">
            {{ insurance.typeText | translate }} - {{ insurance.clinicCarrierName }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <ng-container *ngIf="availableCodes.length || availableProducts.length; else displayCodes">
        <mat-form-field fxFlex *ngIf="availableCodes.length; else productSelect">
          <mat-label>{{ 'dialog.necessity.codes' | translate }}</mat-label>
          <mat-select formControlName="selectedCodes" multiple>
            <mat-option *ngFor="let code of availableCodes" [value]="code">{{ code }}</mat-option>
          </mat-select>
        </mat-form-field>
        <ng-template #productSelect>
          <mat-form-field fxFlex>
            <mat-label>{{ 'dialog.necessity.products' | translate }}</mat-label>
            <mat-select formControlName="selectedProducts" multiple>
              <mat-option *ngFor="let product of availableProducts" [value]="product">{{ product.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </ng-template>
      </ng-container>
      <ng-template #displayCodes>
        <mat-form-field fxFlex>
          <mat-label>{{ 'dialog.necessity.codes' | translate }}</mat-label>
          <input matInput formControlName="codes" />
        </mat-form-field>
      </ng-template>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
  <button mat-button mat-dialog-close>{{ 'common.cancel' | translate }}</button>
  <button
    *appHasPermission="'auth.manager'"
    mat-raised-button
    color="accent"
    (click)="onSaveRule()"
    class="ml-auto"
    [disabled]="saveRuleDisabled$ | async"
  >
    {{ 'dialog.necessity.save-rule' | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    [disabled]="saveDisabled$ | async"
    (click)="onSave()"
  >
    {{ 'common.save' | translate }}
  </button>
</mat-dialog-actions>
